import { Suspense } from 'react';
import { useLocation } from 'react-router';
import { StreamPackagesCard } from '@/routes/_app.p.marketplace.streams/stream-packages-card/stream-packages-card.tsx';
import {
  marketplaceItemsContainer,
  sectionLabel,
} from '@/routes/_app.p.marketplace/page.css.ts';
import { useStreamsLoaderData } from './loader.ts';
import { StreamsFeedFallback } from './streams-feed-fallback.tsx';
import { StreamResults, StreamSearchResults } from './streams-result';

export const StreamsFeed = () => {
  const { key } = useLocation();
  const { queryRef, searchQueryRef } = useStreamsLoaderData();

  const skeletonItemCount = 12;

  return (
    <div className={marketplaceItemsContainer}>
      {queryRef ? (
        <>
          <StreamPackagesCard />
          <Suspense
            key={key}
            fallback={<StreamsFeedFallback count={skeletonItemCount} />}
          >
            <StreamResults
              queryRef={queryRef}
              skeletonItemCount={skeletonItemCount}
            />
          </Suspense>
        </>
      ) : null}

      {searchQueryRef ? (
        <>
          <h2 className={sectionLabel}>Search Results</h2>

          <Suspense
            key={key}
            fallback={<StreamsFeedFallback count={skeletonItemCount} />}
          >
            <StreamSearchResults
              queryRef={searchQueryRef}
              skeletonItemCount={skeletonItemCount}
            />
          </Suspense>
        </>
      ) : null}
    </div>
  );
};
